import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/stillPlayingIcon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ace3fab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_5 = { class: "w-100 mt-4" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          localizedKey: "app_SpiacentiEstrazioneTerminata",
          text: "Spiacenti, estrazione in corso terminata!",
          type: "h3"
        }),
        _createVNode(_component_localized_text, {
          localizedKey: "app_candidatiPerLaProssimaGara",
          text: "Candidati per la prossima gara",
          type: "h3"
        })
      ]),
      _createVNode(_component_form_field, {
        type: "select",
        modelValue: _ctx.stageEventIdentifier,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stageEventIdentifier) = $event)),
        list: _ctx.stages,
        placeholderKey: "app_Scegli evento*",
        placeholderValue: "Scegli evento*",
        class: "mt-4"
      }, null, 8, ["modelValue", "list"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-primary w-100 mb-2",
          disabled: !_ctx.stageEventIdentifier,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.candidate()))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_Candidati",
            text: "Candidati"
          })
        ], 8, _hoisted_6)
      ])
    ])
  ]))
}